export type NoteFormat = 'bold' | 'italic' | 'list';

export interface FormattedNoteContent {
  content: string;
  selectionStart: number;
  selectionEnd: number;
}

export function applyNoteFormat(
  content: string,
  selectionStart: number,
  selectionEnd: number,
  format: NoteFormat,
): FormattedNoteContent {
  const before = content.slice(0, selectionStart);
  const selected = content.slice(selectionStart, selectionEnd);
  const after = content.slice(selectionEnd);

  if (format === 'list') {
    const listItems = (selected || 'list item').split('\n').map((line) => `- ${line}`).join('\n');
    return {
      content: `${before}${listItems}${after}`,
      selectionStart,
      selectionEnd: selectionStart + listItems.length,
    };
  }

  const marker = format === 'bold' ? '**' : '*';
  const editableText = selected || (format === 'bold' ? 'bold text' : 'italic text');
  const formatted = `${marker}${editableText}${marker}`;

  return {
    content: `${before}${formatted}${after}`,
    selectionStart: selectionStart + marker.length,
    selectionEnd: selectionStart + marker.length + editableText.length,
  };
}
